module.exports = __webpack_public_path__ + "img/axians.435e6067.png";